<script setup>
import { usePageArticle } from "@/pages/article/mixin";
import productInfoApiDrive from "@/services/http/api-drive/magasin/produit/productInfo";
import productReviewsApiDrive from "@/services/http/api-drive/magasin/produit/reviews";
import avisVerifiesCodes from "@/utils/avis-verifies-codes";
import { LayoutTypes } from "@/services/context/layout-helper";
import { useContextStore } from "@/store/context";
import { useMagasinStore } from "@/store/magasin";

const app = useNuxtApp();
const { id: magasinId } = useMagasinStore();
const { layout } = useContextStore();
const { params } = useRoute();

const { getAxiosErrorFromAsyncData, getErrorStatus, getErrorMessage } =
  useAxiosHelper();

const shopId = magasinId;
let product;
let breadcrumb;

const { data, error } = await useAsyncData(() =>
  app.$apiDrive
    .use(productInfoApiDrive)
    .productInfoOb(shopId, eanObfuscator(params.ean, parseInt(shopId, 10)))
);
if (data.value) {
  product = data.value.data;
  breadcrumb = data.value.meta.breadcrumb;
}

const responseError = getAxiosErrorFromAsyncData(error);

if (responseError) {
  throw showError({
    statusCode: getErrorStatus(responseError, 504),
    statusMessage: getErrorMessage(responseError)
  });
}

const productId = product.id;
let reviews = {};
let statistics = {};

const { data: reviewsResponse } = await useAsyncData(() => {
  return app.$apiDrive.use(productReviewsApiDrive).reviews({
    shopId,
    productId,
    sortBy: avisVerifiesCodes.DEFAULT_SORT_METHOD,
    pageSize:
      layout === LayoutTypes.mobile
        ? avisVerifiesCodes.DEFAULT_PAGE_SIZE_MOBILE
        : avisVerifiesCodes.DEFAULT_PAGE_SIZE,
    pageIndex: avisVerifiesCodes.DEFAULT_PAGE_INDEX
  });
});

if (reviewsResponse.value) {
  reviews = reviewsResponse.value.data.attributes.reviews;
  statistics = reviewsResponse.value.meta.statistics;
}

const { component, created, head } = usePageArticle();

created();
useHead(head(product));
</script>

<template>
  <component
    :is="component"
    :product="product"
    :push-zones="product.attributes.push_zones"
    :breadcrumb="breadcrumb"
    :reviews="reviews"
    :statistics="statistics"
    :shop-id="shopId"
  />
</template>
